import { RouteConfig } from "vue-router"

export const pricingRoutes: RouteConfig[] = [
    {
        path: "pricing",
        component: () => import("@/layouts/Wrapper.vue"),
        meta: { title: "pricing.title", maintainsContext: true },
        children: [
            {
                path: "",
                name: "PricingUtilityRatePlan",
                component: () => import("@/views/UtilityRatePlan.vue"),
                meta: { title: "Utility Rate Plan", maintainsContext: true },
            },
            {
                path: "price-lists",
                component: () => import("@/layouts/Wrapper.vue"),
                meta: { title: "Price lists", maintainsContext: true },
                children: [
                    {
                        path: "",
                        name: "PricingEnergyPricing",
                        component: () => import("@/views/pricing/EnergyPricing.vue"),
                        meta: { title: "Price lists", maintainsContext: true },
                    },
                    {
                        path: "create",
                        name: "PricingCreatePriceList",
                        component: () => import("@/views/pricing/PriceListView.vue"),
                        meta: { title: "Create rate plan", maintainsContext: true },
                    },
                    {
                        path: ":priceListId",
                        name: "PricingEditPriceList",
                        component: () => import("@/views/pricing/PriceListView.vue"),
                        meta: {
                            title: "Edit pricing plan",
                            maintainsContext: true,
                            useTitle: true,
                        },
                    },
                ],
            },
            {
                path: "spot-market",
                name: "PricingSpotMarket",
                component: () => import("@/views/pricing/SpotMarketView.vue"),
                meta: { title: "Energy Market Prices", maintainsContext: true },
            },
            {
                path: "plans",
                component: () => import("@/layouts/Wrapper.vue"),
                meta: { title: "utility_and_network_plans.time_plan", maintainsContext: true },
                children: [
                    {
                        path: "",
                        name: "PricingUtilityAndNetworkPlans",
                        component: () => import("@/views/pricing/UtilityAndNetworkPlans.vue"),
                        meta: {
                            title: "utility_and_network_plans.time_plan",
                            maintainsContext: true,
                        },
                    },
                    {
                        path: "create",
                        name: "PricingCreatePricingPlan",
                        component: () => import("@/views/pricing/PricingPlanView.vue"),
                        meta: { title: "Create utility plan", maintainsContext: true },
                    },
                    {
                        path: ":planId",
                        name: "PricingEditPricingPlan",
                        component: () => import("@/views/pricing/PricingPlanView.vue"),
                        meta: {
                            title: "Edit utility plan",
                            maintainsContext: true,
                            useTitle: true,
                        },
                    },
                ],
            },
        ],
    },
]
